import { routes as login } from './login'
import { routes as dashboard } from './dashboard'
import { routes as assessment } from './assessment'
import { routes as stream } from './stream'
import { routes as explore } from './explore'
import { routes as programguide } from './programguide'
import { routes as career } from './career'
import { routes as job } from './job'
import { routes as employer } from './employer'

export default [ ...login, ...dashboard, ...assessment, ...stream, ...explore, ...programguide, ...career, ...job, ...employer ]



// WEBPACK FOOTER //
// ./src/app/routes.js